import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'bs5-placeholder-form',
  templateUrl: './bs5-placeholder-form.component.html',
  styleUrls: ['./bs5-placeholder-form.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class Bs5PlaceholderFormComponent {

  @Input()
  rows: number = 1;

  @Input()
  cols: number = 1

  @Input()
  withLabel: boolean = false;

  constructor(private el: ElementRef) {
  }

  counter(i: number) {
    return new Array(i);
  }

  ngOnInit() {
    // var element = this.el.nativeElement;
    // console.log(element);
  }


}
